import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Typography/sp-label";
import * as React from 'react';
export default {
  Content,
  React
};